import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../../../app.config';

/**
 * O interceptor global do CMS injeta `Content-Type: application/json` em TODAS as
 * requisições autenticadas (inclusive GETs, onde o header é ruído sem body).
 * Para o LMS isso é tóxico: endpoints de catálogo (ex.: `GET /v1/lms/courses`)
 * usam o valor do header `Content-Type` como filtro de tipo de mídia quando o
 * parâmetro de query `contentType` está ausente — e `application/json` falha na
 * validação server-side (HTTP 400 "contentType inválido: application/json"),
 * derrubando, entre outros, o select de cursos do diálogo "Nova turma".
 *
 * Este interceptor roda DEPOIS do global (registrado logo após ele) e remove o
 * `Content-Type` apenas das requisições SEM CORPO (GET/HEAD/DELETE/OPTIONS) cujo
 * alvo seja o serviço LMS configurado. POST/PUT com body seguem enviando
 * `application/json`; nenhum outro módulo é afetado.
 */
@Injectable({ providedIn: 'root' })
export class LmsGetWithoutContentTypeInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const lmsBase = AppConfig.data?.['services']?.['lms'] ?? '';
    const isLms = !!lmsBase && req.url.startsWith(lmsBase);
    const noBody = !req.body && ['GET', 'HEAD', 'DELETE', 'OPTIONS'].includes(req.method);

    if (isLms && noBody && req.headers.has('Content-Type')) {
      // Em HttpHeaders do Angular, setar com string vazia REMOVE o header.
      req = req.clone({ headers: req.headers.set('Content-Type', '') });
    }

    return next.handle(req);
  }
}
